<template>
  <div class="practiceChartPage">
    <!-- <button @click="testBtn">testbtn</button> -->
    <canvas id="line" ref="line"></canvas>
    <div class="line_dashed"></div>
    <div class="line_dashed"></div>
    <div class="line_dashed"></div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    type: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      currenData: new Array(),
      canvasline: null,
      linectx: null,
      width: 0,
      height: 0,
      arr: [],
      arr1: [],
      arr2: [],
      arr3: [],
      arr4: [],
      isstop: true,
      loopTimeout: 0,
      max_times: 135,
      points_one_times: 5,
      gride_width: 25,
      gx: 5 * ((25 * 5) / 128),
      x_start: 0, // x 开始位置
      y_starts: 50, // 根据传入线的数量. 判断 Y
      draw_lines_index: [0, 1, 2, 3], // 画线数量
      last_points: [
        [0, 0],
        [0, 0],
        [0, 167],
        [0, 0],
      ], // 点的 xy,
      ecg_scope: 1, // 幅度
      current_times: 0,
      isRefresh: false,
      current_time_millis: 0,

      // aHeartRateData:[],
      data: [0],
      audio: null,
    };
  },
  created() {
    //获取心电图数据
    this.getWave().then((res) => {
      // console.log(this.getWaveChart1);
    });
    this.audio = new Audio();
    this.audio.src = require('../../../assets/po99.wav')
  },
  mounted() {
    this.canvasline = this.$refs.line;
    this.linectx = this.canvasline.getContext("2d");
    this.$nextTick(() => {
      let _width = this.canvasline.offsetWidth;
      let _height = this.canvasline.offsetHeight;
      this.canvasline.width = _width;
      this.canvasline.height = _height;
      this.width = this.canvasline.width;
      this.height = this.canvasline.height;
      // 初始化参数, 宽度, 和线条颜色
      this.initparm();
      // 转换数据
      this.Convert16Scale();
      this.loop();
    });
  },
  unmounted() {
    clearTimeout(this.loopTimeout);
    this.isstop = false;
  },
  methods: {
    ...mapActions({
      setWave: "exma/setWave",
    }),
    async getWave() {
      if (this.waveList.length != 0) return;
      try {
        let res = await this.$http.get(this.$interface.waveList);
        this.setWave(res.data.data || []);
      } catch (err) {}
    },
    testBtn() {
      this.loop();
    },
    draw(Q, B, P, N, G, H, A, E) {
      //设置清除重新绘制位置
      this.current_times = this.current_times % G;
      if (this.IsEmpty()) {
        return;
      }
      if (this.GetSize() < H) {
        return;
      }
      this.clearcanvans(this.current_times, H, N, A);
      let F = new Array();
      for (let J = 0; J < H; J++) {
        F.push(this.DeQueue());
      }

      for (let J = 0; J < E.length; J++) {
        // console.log(J,'J')
        A.beginPath();
        if (J == 0 || J == 1) {
          A.strokeStyle = "rgba(61, 252, 182, 1)";
        } else if (J == 2) {
          A.strokeStyle = "rgba(28, 168, 255, 1)";
        } else if (J == 3) {
          A.strokeStyle = "rgba(61, 252, 182, 1)";
        }
        for (let K = 0; K < F.length; K++) {
          // console.log(K,'k')
          let O = F[K];
          let C = O[E[J]] + 23;

          if (this.last_points[J][1] == 0 || !this.last_points[J][1]) {
            if (J == 0) this.last_points[J][1] = 27 + 23;
            if (J == 1) this.last_points[J][1] = 94 + 23;
            if (J == 2) this.last_points[J][1] = 76 * 3 + 27 + 23;
            if (J == 3) this.last_points[J][1] = 70 * 2 + 27 + 23;
          }

          let I = K * parseFloat((this.gride_width * 5) / N);
          let L = parseFloat(
            this.x_start + this.current_times * H * ((this.gride_width * 5) / N)
          );

          if (K == 0) {
            if (this.current_times != 0) {
              A.moveTo(this.last_points[J][0], this.last_points[J][1]);
              let D = C;
              A.lineTo(this.last_points[J][0], D);
              this.last_points[J][0] = this.last_points[J][0];
              this.last_points[J][1] = D;
            } else {
              let D = C;
              A.moveTo(this.x_start, D);
              this.last_points[J][0] = this.x_start;
              this.last_points[J][1] = D;
            }
          } else {
            let D = C;
            A.lineTo(L + I, D);
            this.last_points[J][0] = L + I;
            this.last_points[J][1] = D;
          }
        }
        A.stroke();
      }

      this.current_times++;
    },

    // 转换数据
    Convert16Scale() {
      // this.arr = JSON.parse(JSON.stringify(this.getWaveChart1));
      // this.arr1 = JSON.parse(JSON.stringify(this.getWaveChart2));
      // this.arr2 = JSON.parse(JSON.stringify(this.getWaveChart3));
      // this.arr3 = JSON.parse(JSON.stringify(this.getWaveChart6));
      // this.arr4 = [];
      this.adddata();
    },
    loop() {
      if (!this.isstop) {
        return;
      }
      this.draw(
        this.y_starts,
        128,
        52,
        128,
        this.max_times,
        this.points_one_times,
        this.linectx,
        this.draw_lines_index
      );
      window.requestAnimationFrame(() => {
        this.loop();
      });
      if (this.IsEmpty()) {
        this.Convert16Scale();
      }
    },
    loop1() {
      let _time = 62;
      let A = new Date().getTime();
      this.current_time_millis = A; // 划线前时间戳
      this.draw(
        this.y_starts,
        128,
        52,
        128,
        this.max_times,
        this.points_one_times,
        this.linectx,
        this.draw_lines_index
      );
      if (this.isstop) {
        setTimeout(this.loop, _time);
        let C = new Date().getTime(); // 划线后时间戳
        // 后 - 前时间戳 + 1 就是一定要间隔 62 毫秒, 不然就休眠补足时间
        let B = C - this.current_time_millis + 1;
        if (B < _time) {
          this.sleep(_time - B);
        }
      }
      if (this.IsEmpty()) {
        this.Convert16Scale();
      }
    },
    clearcanvans(B, F, C, D) {
      let A = parseFloat(F * ((this.gride_width * 5) / C));
      let E = this.x_start + B * A;
      // 清除 20 的地方用来重新划线
      if (B != 0) {
        D.clearRect(E, 0, 20, this.height);
      } else {
        D.clearRect(E - 10, 0, E + 20, this.height);
      }
    },
    adddata(F, C, E) {
      // if(this.arr.length == 0 && this.arr3.length == 0)return;
      for (let A = 0; A < 10; A++) {
        let G = [];

        if (!this.arr.length) {
          this.arr = JSON.parse(JSON.stringify(this.getWaveChart1));
        }
        G[0] = this.arr.shift();
        if (G[0] >= 30 && this.$parent.isPlay) {
          // 待开启
          this.audio.play()
        }

        if (!this.arr1.length) {
          this.arr1 = JSON.parse(JSON.stringify(this.getWaveChart2));
        }
        G[1] = this.arr1.shift() + 66;

        if (!this.arr2.length) {
          this.arr2 = JSON.parse(JSON.stringify(this.getWaveChart3));
        }
        G[2] = this.arr2.shift() + 76 * 3;

        if (!this.arr3.length) {
          this.arr3 = JSON.parse(JSON.stringify(this.getWaveChart6));
        }
        let arr3item = this.arr3.shift();
        if (arr3item) {
          G[3] = arr3item + 70 * 2;
        } else {
          G[3] = undefined;
        }
        // G[3] = this.arr3[A]?this.arr3[A]+70*2:undefined;
        this.EnQueue(G);
      }
    },
    adddata1(F, C, E) {
      // if(this.arr.length == 0 && this.arr3.length == 0)return;
      for (let A = 0; A < 10; A++) {
        let G = [];
        G[0] = this.arr[A];
        G[1] = this.arr1[A] + 66;
        G[2] = this.arr2[A] + 76 * 3;
        G[3] = this.arr3[A] ? this.arr3[A] + 70 * 2 : undefined;
        this.EnQueue(G);
      }
    },
    // 初始化参数, 宽度, 和线条颜色
    initparm() {
      this.max_times = parseInt((this.width - 0) / this.gx);
      //   this.linectx.translate(0.5,0.5);
      this.linectx.lineWidth = 2;
      this.linectx.strokeStyle = "rgba(16, 87, 229, 1)";
    },

    sleep(B) {
      let A = new Date().getTime();
      for (let C = 0; C < 10000000; C++) {
        if (new Date().getTime() - A > B) {
          break;
        }
      }
    },
    EnQueue(C) {
      if (C == null) {
        return -1;
      }
      if (this.currenData.length >= this.capacity) {
        this.currenData.remove(0);
      }
      this.currenData.push(C);
    },
    DeQueue() {
      if (this.currenData.length == 0) {
        return null;
      } else {
        return this.currenData.shift();
      }
    },
    GetSize() {
      return this.currenData.length;
    },
    IsEmpty() {
      if (this.currenData.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    clear(C) {
      this.currenData = new Array();
    },
  },
  watch: {},
  computed: {
    ...mapGetters([
      "getWaveChart1",
      "getWaveChart2",
      "getWaveChart3",
      "getWaveChart4",
      "getWaveChart5",
      "getWaveChart6",
      "waveList",
      "stepInfo",
      "jianhuyiDisplay",
    ]),
  },
};
</script>
<style lang="scss">
@import "../index.scss";
</style>
